import RestError, { StorageError } from '../app/errors';

export class SlipExpiredError extends StorageError {}
export class SlipIncorrectError extends RestError {}
export class SlipConflictError extends RestError {}
export class SlipUnsupportedShopError extends RestError {}
